export default "__VITE_ASSET__m9_rQ9h6__"